import iconCricket from "../../../image/1.png";
import iconShuttle from "../../../image/2.png";
import iconBasket from "../../../image/3.png";
import iconTennis from "../../../image/4.png";
import iconBats from "../../../image/5.png";
import iconPool from "../../../image/6.png";
import iconVolleyball from "../../../image/7.png";
import iconFootball from "../../../image/8.png";

export const sportImgByName = (raw) => {
  const n = (raw || "").toLowerCase();
  if (/foot|soccer|turf/.test(n)) return iconFootball;
  if (/cricket|bat/.test(n)) return iconCricket;
  if (/badm|shuttle|racquet|racket|pickle/.test(n)) return iconShuttle;
  if (/basket/.test(n)) return iconBasket;
  if (/tennis/.test(n)) return iconTennis;
  if (/volley/.test(n)) return iconVolleyball;
  if (/pool|swim|table/.test(n)) return iconPool;
  if (/baseball|gym|fitness/.test(n)) return iconBats;
  return iconFootball;
};

/** Font Awesome icon class for amenity labels */
export const amenityIconByName = (raw) => {
  const n = String(raw || "").toLowerCase();
  if (/parking|car|vehicle/.test(n)) return "fa-solid fa-square-parking";
  if (/wifi|wi-fi|internet|wireless/.test(n)) return "fa-solid fa-wifi";
  if (/shower|washroom|toilet|restroom|bathroom|wash/.test(n))
    return "fa-solid fa-shower";
  if (/locker|changing|dress/.test(n)) return "fa-solid fa-key";
  if (/cafe|food|refreshment|snack|cafeteria|canteen/.test(n))
    return "fa-solid fa-mug-hot";
  if (/water|drink|cooler/.test(n)) return "fa-solid fa-droplet";
  if (/light|flood|led/.test(n)) return "fa-solid fa-lightbulb";
  if (/first aid|medical|doctor/.test(n)) return "fa-solid fa-kit-medical";
  if (/coach|trainer|training/.test(n)) return "fa-solid fa-person-chalkboard";
  if (/equipment|rental|gear/.test(n)) return "fa-solid fa-dumbbell";
  if (/cctv|security|camera/.test(n)) return "fa-solid fa-video";
  if (/ac|air condition|cooling/.test(n)) return "fa-solid fa-snowflake";
  if (/seating|bleacher|stand|gallery/.test(n)) return "fa-solid fa-chair";
  if (/turf|grass|ground|field/.test(n)) return "fa-solid fa-seedling";
  if (/score|board|display/.test(n)) return "fa-solid fa-display";
  if (/shop|store|pro shop/.test(n)) return "fa-solid fa-store";
  if (/wheelchair|accessible|disabled/.test(n)) return "fa-solid fa-wheelchair";
  if (/power|charging|socket/.test(n)) return "fa-solid fa-plug";
  if (/music|sound|speaker/.test(n)) return "fa-solid fa-volume-high";
  return "fa-solid fa-circle-check";
};

export const formatCategoryLabel = (cat) =>
  String(cat || "Outdoor")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/[-_]/g, " ");

export const BOOKING_STEPS = [
  { step: 1, label: "Date", icon: "fa-solid fa-calendar-day" },
  { step: 2, label: "Activity", icon: "fa-solid fa-bolt" },
  { step: 3, label: "Court", icon: "fa-solid fa-table-cells-large" },
  { step: 4, label: "Time", icon: "fa-solid fa-clock" },
];

export const CONTENT_NAV = [
  {
    id: "about",
    label: "About",
    icon: "fa-solid fa-circle-info",
    hint: "Description & highlights",
  },
  {
    id: "amenities",
    label: "Amenities",
    icon: "fa-solid fa-wand-magic-sparkles",
    hint: "Facilities on site",
  },
  {
    id: "gallery",
    label: "Photos",
    icon: "fa-solid fa-images",
    hint: "See the venue",
  },
  {
    id: "reviews",
    label: "Reviews",
    icon: "fa-solid fa-star",
    hint: "Guest experiences",
  },
  {
    id: "location",
    label: "Map",
    icon: "fa-solid fa-map-location-dot",
    hint: "Directions & address",
  },
  {
    id: "nearby",
    label: "Nearby",
    icon: "fa-solid fa-compass",
    hint: "More venues around you",
  },
];

export const DEFAULT_RULES = [
  {
    title: "Booking required",
    text: "Entry only with confirmed booking.",
  },
  { title: "Slot timing", text: "Leave the court when your slot ends." },
  { title: "Refunds", text: "As per cancellation policy." },
  { title: "No food on turf", text: "Water bottles only on court." },
  { title: "No smoking", text: "Smoking and alcohol prohibited." },
  { title: "Equipment", text: "Damage may be chargeable." },
];
